import Sidebar from "./SideBar.vue";

const SIDEBAR = {
  ADMIN: "ADMIN",
  SUPPORT: "SUPPORT",
  NONE: "NONE",
};

const adminLinks = [
  {
    name: "Dashboard",
    icon: "ti-dashboard",
    path: "/admin/home",
    collapse: false,
    subLinks: [],
  },
  {
    name: "Aprovações",
    icon: "ti-clipboard",
    path: "/admin/vendedores/lista",
    collapse: false,
    subLinks: [
      {
        name: "Anúncios",
        icon: "ti-package",
        path: "/admin/vendedores/lista",
      },
      {
        name: "lojistas",
        icon: "ti-view-list-alt",
        path: "/admin/lojistas/lista",
      },
    ],
  },
  {
    name: "Anúncios",
    icon: "ti-package",
    path: "/admin/anuncios/lista",
    collapse: false,
    subLinks: [],
  },
  {
    name: "Ofertas",
    icon: "ti-hummer",
    path: "/admin/ofertas/lista",
    collapse: false,
    subLinks: [],
  },
  {
    name: "Usuários",
    icon: "ti-user",
    path: "/admin/usuarios/lista",
    collapse: false,
    subLinks: [],
  },
  {
    name: "Vip",
    icon: "ti-star",
    path: "/admin/vip/lista",
    collapse: false,
    subLinks: [],
  },
  {
    name: "Cobranças",
    icon: "ti-money",
    path: "/admin/cobrancas/lista",
    collapse: false,
    subLinks: [],
  },
  {
    name: "Notificações",
    icon: "ti-bell",
    path: "/admin/notificacoes/lista",
    collapse: false,
    subLinks: [],
  },
  {
    name: "Ferramentas",
    icon: "ti-clip",
    path: "",
    collapse: false,
    subLinks: [
      {
        name: "Categorias",
        icon: "ti-layers-alt",
        path: "/admin/categorias/lista",
        collapse: false,
        subLinks: [],
      },
      {
        name: "Tipo de Combustivel",
        icon: "ti-layers-alt",
        path: "/admin/tipocombustivel/lista",
        collapse: false,
        subLinks: [],
      },
      {
        name: "Cores",
        icon: "ti-layers-alt",
        path: "/admin/colors/lista",
        collapse: false,
        subLinks: [],
      },
    ],
  },
  // {
  //   name: 'Promoções',
  //   icon: 'ti-announcement',
  //   path: '/admin/promocoes/lista',
  //   collapse: false,
  //   subLinks: []
  // },
  {
    name: "Suporte",
    icon: "ti-headphone-alt",
    path: "/admin/suportes/lista",
    collapse: false,
    subLinks: [],
  },

  {
    name: "Trocar Senha",
    icon: "ti-lock",
    path: "/admin/senha/editar",
    collapse: false,
    subLinks: [],
  },
  {
    name: "Configurações",
    icon: "ti-settings",
    path: "/admin/configuracoes/editar",
    collapse: false,
    subLinks: [],
  },
];

const SidebarStore = {
  showSidebar: false,
  sidebarLinks: [],

  displaySidebar(value) {
    this.showSidebar = value;
  },
  updateSidebar(value) {
    this.sidebarLinks = adminLinks;

    this.showSidebar = "ADMIN";
  },
};

const SidebarPlugin = {
  install(Vue) {
    Vue.mixin({
      data() {
        return {
          sidebarStore: SidebarStore,
        };
      },
    });

    Object.defineProperty(Vue.prototype, "$sidebar", {
      get() {
        return this.$root.sidebarStore;
      },
    });
    Vue.component("side-bar", Sidebar);
  },
};

export default SidebarPlugin;



// WEBPACK FOOTER //
// ./src/components/UIComponents/SidebarPlugin/index.js